var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        { staticClass: "commissions-details-container" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex align-items-center",
                  attrs: { lg: "6" },
                },
                [
                  _c("span", { staticClass: "bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "direct-to-lender.commissions.commissionDetails.applyDeductions"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "fieldset",
                    {
                      staticClass: "d-inline-block ml-3",
                      attrs: { id: "split-moment" },
                    },
                    [
                      _c("div", { staticClass: "pretty p-icon p-round" }, [
                        _c("input", {
                          staticClass: "form-check-input",
                          attrs: {
                            id: "split-moment--before",
                            type: "radio",
                            name: "split-moments",
                            value: "none",
                            disabled: _vm.isReadOnly,
                          },
                          domProps: { checked: _vm.isBeforeSplit },
                          on: {
                            change: function ($event) {
                              return _vm.changeSplitType("before")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "state p-primary-o" }, [
                          _c("i", { staticClass: "icon fa fa-check" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "clickable text-light-gray",
                              attrs: { for: "split-moment--before" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "direct-to-lender.commissions.commissionDetails.beforeSplit"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pretty p-icon p-round p-smooth" },
                        [
                          _c("input", {
                            staticClass: "form-check-input",
                            attrs: {
                              id: "split-moment--after",
                              type: "radio",
                              name: "split-moments",
                              value: "none",
                              disabled: _vm.isReadOnly,
                            },
                            domProps: { checked: !_vm.isBeforeSplit },
                            on: {
                              change: function ($event) {
                                return _vm.changeSplitType("after")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "state p-primary-o" }, [
                            _c("i", { staticClass: "icon fa fa-check" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "clickable text-light-gray",
                                attrs: { for: "split-moment--after" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.commissions.commissionDetails.afterSplit"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex align-items-center",
                  attrs: { lg: "6" },
                },
                [
                  _c(
                    "field",
                    {
                      staticClass: "mb-0 w-100",
                      attrs: {
                        title: _vm.$t(
                          "direct-to-lender.commissions.commissionDetails.totalNetFees"
                        ),
                        "side-label-size": "col-auto",
                        "side-label": "",
                        "container-class": "dollar-prepend w-30",
                        calculated: "",
                      },
                    },
                    [
                      _c("text-section", {
                        staticClass: "mb-0",
                        attrs: {
                          value: _vm.totalNetFees,
                          placeholder: "0.00",
                          "class-name": "calculated dollar",
                          calculated: "",
                          decimals: 2,
                          "allow-minus": "",
                          label: _vm.$t(
                            "direct-to-lender.commissions.commissionDetails.totalNetFees"
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "my-3" },
            [
              _c("commission-details-table", {
                attrs: {
                  "agent-username": _vm.agentUsername,
                  "client-username": _vm.clientUsername,
                  "application-id": _vm.applicationId,
                  "mortgage-type": _vm.mortgageType,
                  participants: _vm.participants,
                  "total-net-fees": _vm.totalNetFees,
                  deductions: _vm.afterSplitDeduction,
                  "is-read-only": _vm.isReadOnly,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "pt-3" },
            [
              _c("b-col", [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn clickable text-primary bold bs-0 px-0 btn-transparent",
                    attrs: { disabled: _vm.isReadOnly },
                    on: { click: _vm.showAddParticipantModal },
                  },
                  [
                    _vm._v(
                      "\n        +\n        " +
                        _vm._s(
                          _vm.$t(
                            "direct-to-lender.commissions.commissionDetails.addParticipant"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("add-participant-modal", {
            ref: "addParticipantModal",
            on: { "selected-participant": _vm.handleAddParticipant },
          }),
        ],
        1
      )
    : _c("commission-details-loader")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }